<div class="min-h-screen flex items-center justify-center bg-gray-50">
  <div class="text-center">
    <div *ngIf="isLoading" class="flex flex-col items-center">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      <p class="mt-4 text-gray-600">Activating impersonation session...</p>
    </div>

    <div *ngIf="errorMessage && !isLoading" class="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md">
      <p class="text-red-800 font-medium">{{ errorMessage }}</p>
    </div>
  </div>
</div>
